import React from 'react';
import { Colors, Text } from 'library';
import { styled } from '@mui/material';
import { ToggleGroup } from 'library/ui';

import { useUserContext } from 'UserContext';
import { useRequirementsAndPayContext } from '../context';
import { booleanChoice } from '../utils/choices';
import { updateScale } from '../utils/scale';
import { shouldToggleFortyFiveHours } from '../utils/vpk';
import type { VpkAnswer } from '../utils/vpk';
import { vpkClassroomQuestion, vpkClassroomHelperText } from '../vpkClassroomQuestion';

export function VpkClassroomQuestion() {
    const { user } = useUserContext();
    const { qualifications, initialScale, updateScales, isVpkClassroom } = useRequirementsAndPayContext();
    const { boolean } = qualifications;

    const hasVpkLocation = (user?.businesses_active ?? []).some(
        (business) => business[vpkClassroomQuestion.businessFlag],
    );
    const fortyFiveHours = boolean?.find((bool) => bool.value === vpkClassroomQuestion.requiredQualification);

    function setVpkClassroom(answer: VpkAnswer) {
        if (!isVpkClassroom) return;
        isVpkClassroom.setValue(answer === 'yes');
        if (!fortyFiveHours || !initialScale) return;
        if (shouldToggleFortyFiveHours(answer, booleanChoice(initialScale, fortyFiveHours))) {
            updateScales(updateScale(initialScale, fortyFiveHours.key, [fortyFiveHours], null, 'boolean'));
        }
    }

    if (!isVpkClassroom || !hasVpkLocation || !fortyFiveHours) return null;

    const vpkAnswer: VpkAnswer = isVpkClassroom.value ? 'yes' : 'no';

    return (
        <VpkBox>
            <Text bold textStyle={{ color: Colors.primary }}>
                {vpkClassroomQuestion.prompt}
            </Text>
            <Text variant="body2" textStyle={{ color: Colors.textSecondary, marginBottom: 8 }}>
                {vpkClassroomHelperText}
            </Text>
            <ToggleGroup
                options={[
                    { label: 'Yes', value: 'yes' },
                    { label: 'No', value: 'no' },
                ]}
                value={vpkAnswer}
                onChange={(value) => setVpkClassroom(value as VpkAnswer)}
            />
        </VpkBox>
    );
}

const VpkBox = styled('div')({
    marginTop: 16,
    padding: '12px 14px',
    backgroundColor: Colors.surface,
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
});
